export default __webpack_public_path__ + "static/media/Mark-6-Blueprints-01.7c00d839.jpg";